import { useState } from "react"
import { Pannellum } from "pannellum-react";

import fantasyNight from '../images/realistic_sky_color_red_and_orange_water_fall.jpg'
import fantasyCave from '../images/sky_inside_a_space_ship_looking_at_the_earth.jpg'
import YouTubePlaylist from "../components/youtubePlaylist";

const Trey = () => {
    const [currentScene, setCurrentScene] = useState(fantasyNight);
    const playlist = "https://www.youtube.com/embed/videoseries?list=PLaqPzNpBaE7wz0jO0vby92RCpGetnkS5R"
    return (
        <>
            <div className="h-screen w-screen flex">
                <Pannellum
                    width="100%"
                    height="100%"
                    image={currentScene}
                    yaw={300}
                    hfov={110}
                    autoLoad
                    autoRotate={-5}
                    compass={true}
                    showZoomCtrl={false}
                    mouseZoom={false}
                    onLoad={() => {
                        console.log("panorama loaded");
                    }}
                >
                    <Pannellum.Hotspot
                    className="z-60"
                        type="custom"
                        pitch={-10}
                        yaw={-120}
                        handleClick={(evt, name) =>
                            setCurrentScene(currentScene !== fantasyNight ? fantasyNight : fantasyCave)
                        }
                    />
                </Pannellum>
                <YouTubePlaylist src={playlist}/>
            </div>
        </>
    )
}
export default Trey